import React, { useEffect, useState } from 'react'
import { Text, Image, View, Svg, Path } from '@react-pdf/renderer'

// evertel
import { useService } from '@evertel/di'
import { Api } from '@evertel/api'
import { APIDataMedia } from '@evertel/types'
import { SchemaMediaController } from '../../controller/medias/SchemaMediaController'
import Wrapper from './Wrapper'


interface CheckboxOption {
    value: string
    label?: string
    image?: number | string
}

interface CheckboxReadWidgetProps {
    value: string|string[]
    title: string
    label?: string
    options?: CheckboxOption[]
    schemaId?: number
    description?: string
}

const CheckboxReadWidget: React.FC<CheckboxReadWidgetProps> = ({
    value = [],
    title,
    label,
    options,
    schemaId,
    ...otherProps
}) => {

    const values = Array.isArray(value) ? value : (value != null ? [value] : [])

    const api = useService(Api)
    const fieldMediaController = useService(SchemaMediaController, [schemaId])

    const [media, setMedia] = useState<APIDataMedia[]>([])

    useEffect(() => {
        (async () => {
            const mediaIds: number[] = []
            options?.forEach(o => {
                if (o.image && typeof o.image === 'number') {
                    mediaIds.push(o.image)
                }
            })

            await fieldMediaController.init(schemaId, mediaIds)
            setMedia(fieldMediaController.mediaArrays?.uploaded || [])
        })()
    }, [schemaId])

    return (
        <Wrapper
            value={value}
            title={title}
            {...otherProps}
        >
            {!values?.length && (
                <Text style={{ color: '#6b7280' }}>
                    ---
                </Text>
            )}
            {!options?.length && (
                <View style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                }}>
                    <View style={{
                        width: 12,
                        height: 12,
                        border: `1.5pt solid ${value ? '#22c55e' : 'black' }`,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: 4
                    }}>
                        {value && (
                            <Text style={{
                                color: '#22c55e',
                                fontSize: 10,
                                lineHeight: 1
                            }}>✓</Text>
                        )}
                    </View>
                    <Text style={{ fontSize: 10 }}>
                        {label}
                    </Text>
                </View>
            )}
            {options?.length > 0 && (
                <View style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap'
                }}>
                    {options.map((option, idx) => {
                        const isChecked = values.includes(option.value)
                        const image = option.image ? media.find(m => m.id === Number(option.image)) : undefined

                        // Skip rendering options that aren't checked
                        if (!isChecked) return null

                        return (
                            <View key={idx} style={{
                                marginRight: 15,
                                marginBottom: 10,
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                <View style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    marginBottom: 4
                                }}>
                                    <View style={{
                                        position: 'relative',
                                        width: 12,
                                        height: 12,
                                        border: '1.5pt solid #008000',
                                        borderRadius: 2,
                                        marginRight: 4
                                    }}>
                                        <Svg viewBox="0 0 14 14">
                                            <Path
                                                d="M3 7L6 10L11 4"
                                                fill="none"
                                                stroke="#008000"
                                                strokeWidth={3}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </Svg>
                                    </View>
                                    <Text style={{ fontSize: 10 }}>
                                        {option.label}
                                    </Text>
                                </View>

                                {image && (
                                    <Image
                                        src={{
                                            uri: image.url,
                                            method: 'GET',
                                            headers: {Authorization: api.authToken}
                                            // credentials: 'omit'
                                        }}
                                        style={{
                                            width: 100,
                                            height: 66
                                        }}
                                    />
                                )}
                            </View>
                        )
                    }).filter(Boolean)}
                </View>
            )}
        </Wrapper>
    )
}

CheckboxReadWidget.displayName = 'CheckboxReadWidget (PDF)'

export default CheckboxReadWidget
